<template>
  <div class="wechat-login">
    <div class="login-title">其他登录方式</div>
    <ym-icon class="wechat-icon"
             name="WeChat"
             v-ym-report:[recordName]=""
             @click="handleLoginWithWeChat"
    />
  </div>
</template>

<script>
  import {
    isWeiXinBrowser,
    locationHref,
    getStorageRedirect,
    getQuery,
  } from '@/utils';
  import { getLoginWeChatUrl } from '@/services/user';

  export default {
    name: 'WechatLogin',
    props: {
      type: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        weChatLoginUrl: '',
      };
    },
    computed: {
      inWeChat() {
        return isWeiXinBrowser();
      },
      query() {
        return getQuery(this.$route.query);
      },
      agency() {
        return this.query && this.query.agency ? parseInt(this.query.agency, 10) : 0;
      },
      recordName() {
        if (this.type === 'login') return 'LOGIN_WECHAT_BUTTON_CLICK';
        return 'REGISTER_WECHAT_BUTTON_CLICK';
      },
    },
    methods: {
      async fetchData() {
        if (this.inWeChat) {
          const { redirectTo } = this.query;
          const path = getStorageRedirect(redirectTo);
          const data = await getLoginWeChatUrl({
            redirectTo: path,
            agency: this.agency,
          });
          this.weChatLoginUrl = data;
        }
      },
      async handleLoginWithWeChat() {
        if (this.weChatLoginUrl === '') {
          await this.fetchData();
        }
        locationHref(this.weChatLoginUrl);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .wechat-login {
    position: absolute;
    bottom: 58px;
    width: 100%;
    text-align: center;
  }

  .login-title {
    position: relative;
    color: @color-text-lighter;
    font-size: @font-size-base;
    text-align: center;
    &:before {
      content: '';
      position: absolute;
      width: 100px;
      height: 1px;
      background-color: #eee;
      top: 50%;
      left: 22%;
    }
    &:after {
      content: '';
      position: absolute;
      width: 100px;
      height: 1px;
      background-color: #eee;
      top: 50%;
      right: 22%;
    }
  }

  .wechat-icon {
    font-size: 84px;
    margin-top: 40px;
  }
</style>
